import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'firstLetters'
})
export class FirstLettersPipe implements PipeTransform {

  transform(value: string, ...args: any[]): string {
    if (!value) {
      return '';
    }

    const words = value.trim().split(' ').join('').split('');

    if (words.length < 2) {
      return '';
    }

    const firstLetters = words.slice(0, 2)
      .map(word => word.charAt(0).toUpperCase())
      .join('');
    return firstLetters;
  }

}
